module.exports = __webpack_public_path__ + "static/media/back_01.11a2f1ef.png";